import { render, staticRenderFns } from "./vehicleDetailContent.vue?vue&type=template&id=484a028c"
import script from "./vehicleDetailContent.vue?vue&type=script&lang=js"
export * from "./vehicleDetailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports